module.exports = __webpack_public_path__ + "static/media/meta_skeletoid.585d1f0d.png";